import type { HydraContext } from "../hydra.interface";
import type { NotificationConditionDocument } from "./notificationCondition.interface";

export enum NotificationChannelEnum {
  INBOX = 1,
  EMAIL = 2,
  WEB_PUSH = 3,
  MOBILE_APP = 4,
}

export type NotificationChannel = "inbox" | "email" | "web_push" | "mobile_app";

export const NotificationChannelToEnum: Record<NotificationChannel, NotificationChannelEnum> = {
  inbox: NotificationChannelEnum.INBOX,
  email: NotificationChannelEnum.EMAIL,
  web_push: NotificationChannelEnum.WEB_PUSH,
  mobile_app: NotificationChannelEnum.MOBILE_APP,
};

export const NotificationEnumToChannel: Record<NotificationChannelEnum, NotificationChannel> = {
  [NotificationChannelEnum.INBOX]: "inbox",
  [NotificationChannelEnum.EMAIL]: "email",
  [NotificationChannelEnum.WEB_PUSH]: "web_push",
  [NotificationChannelEnum.MOBILE_APP]: "mobile_app",
};

export interface NotificationRuleHydraItem extends HydraContext {
  "@type": "NotificationRule"
  "subscription": string
  "topic": string
  "channel": NotificationChannelEnum
  "sound": boolean
  "conditions": NotificationConditionDocument[]
  "active": boolean
  "createdAt": string
  "updatedAt"?: string | null
}

export type NotificationRuleHydraCollectionItem = NotificationRuleHydraItem;
